import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getListTicket, updateDataSearch } from "actions/Ticket";
import { ThemMoiCapDuyet } from "./ThemMoiCapDuyet";
import { AddTaiKhoanDesktopBtn } from "./AddTaiKhoanDesktopBtn";
export const AddTaiKhoanBtn = (data, onSearch) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };
  return (
    <div className="hide-table-main show-mobile-main hidden-des-main">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginTop: 15,
          marginBottom: 15,
        }}
      >
        <div style={{ display: "block" }}>
          <div className="row">
            <div className="col-sm-12 col-md-9">
              <button
                type="button"
                className="btn btn-border-new"
                onClick={handleShow}
              >
                <img
                  src="/app-assets/images/icon-them-moi-cam-do-v2.png"
                  style={{ paddingBottom: "5px" }}
                />{" "}
                Thêm mới
              </button>
            </div>
          </div>
        </div>
        {show && (
          <ThemMoiCapDuyet data={data} show={show} onHide={handleClose} />
        )}
      </div>
    </div>
  );
};
